import AcceleratorDoc from "../AcceleratorDoc";
import API from "../API";
import { BaseField, BaseFieldData } from "../extraction/BaseField";

class RunDlfReuse {
  docType: string;
  fieldName: string;

  constructor(docType: string, fieldName: string) {
    this.docType = docType;
    this.fieldName = fieldName;
  }

  async calculate(
    acceleratorDoc: AcceleratorDoc,
  ): Promise<RunDlfReuseResponse | null> {
    return await API.get(`/v0/reuse/${acceleratorDoc.uuid}/generate`, {
      docType: this.docType,
      fieldName: this.fieldName,
    })
      .then((value: Response) => value.json())
      .then((value: RunDlfReuseResponseData) => new RunDlfReuseResponse(value))
      .catch((error: string) => {
        // console.log(error);
        return null;
      });
  }
}

interface RunDlfReuseResponseData {
  valid: boolean;
  reason: string;
  results: BaseFieldData[];
}
class RunDlfReuseResponse {
  valid: boolean;
  reason: string;
  results: BaseField[];

  constructor(data: RunDlfReuseResponseData) {
    this.valid = data.valid;
    this.reason = data.reason;
    // TODO: populate properly
    this.results = data.results.map((result) => new BaseField(result));
  }
}

export { RunDlfReuse, RunDlfReuseResponse };
